import React from "react";
import uuid from "react-uuid";

import NavigationItem from "../../model/NavigationItem";

import {
    StyledNavLink,
    StyledNavLinkActive,
} from "../../styles/components/NavBarStyles";

interface IActiveStyle {
    color: string;
}

interface IMenuSubItem {
    activeStyle: IActiveStyle;
    menuItem: (title: string) => React.ReactNode;
    navItems: NavigationItem[];
}

const MenuSubItem = ({ activeStyle, menuItem, navItems }: IMenuSubItem) => {
    const menuSubItems = navItems?.map((group) => {
        return (
            <StyledNavLinkActive
                activeStyle={activeStyle}
                to={`/${group.path}`}
                key={uuid()}
            >
                {menuItem(group.title)}
            </StyledNavLinkActive>
        );
    });

    return <StyledNavLink>{menuSubItems}</StyledNavLink>;
};

export default MenuSubItem;
